import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "./components/layout/AppLayout";
import { Home } from "./pages/Home";
import { Moldova } from "./pages/Moldova";
import { MoldovaScreening } from "./pages/MoldovaScreening";
import { Forroca } from "./pages/Forroca";
import { RoVineEnergy } from "./pages/RoVineEnergy";
import { Israel } from "./pages/Israel";
import { Programs } from "./pages/Programs";
import { ProgramDetail } from "./pages/ProgramDetail";
import { Insights, InsightDetail } from "./pages/Insights";
import { About } from "./pages/About";
import { Transparency } from "./pages/Transparency";
import { Contact } from "./pages/Contact";
import { NotFound, Privacy, Terms } from "./pages/Legal";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/en/" replace />} />
      <Route path="/forroca" element={<AppLayout />}>
        <Route index element={<Forroca />} />
      </Route>
      <Route path="/:locale" element={<AppLayout />}>
        <Route index element={<Home />} />
        <Route path="moldova" element={<Moldova />} />
        <Route path="moldova/screening" element={<MoldovaScreening />} />
        <Route path="evaluare-energetica-vinarii" element={<RoVineEnergy />} />
        <Route path="israel" element={<Israel />} />
        <Route path="programs" element={<Programs />} />
        <Route path="programs/:slug" element={<ProgramDetail />} />
        <Route path="insights" element={<Insights />} />
        <Route path="insights/:slug" element={<InsightDetail />} />
        <Route path="about" element={<About />} />
        <Route path="transparency" element={<Transparency />} />
        <Route path="contact" element={<Contact />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="*" element={<Navigate to="/en/" replace />} />
    </Routes>
  );
}
